import { all } from "redux-saga/effects";
import { watcherInit } from "./init";
import { watcherAuth } from "./auth";
import { watcherProject } from "./project";
import { watcherProvince } from "./province";
import { watcherContact } from "./contact";
import { watcherAccountReview } from "./accountReview";
import { watcherFund } from "./fund";
import { watcherBankAccount } from "./bankAccount";
import { watcherBank } from "./bank";
import { watcherPayment } from "./payment";
import { watcherReceive } from "./receive";
import { watcherTransfer } from "./transfer";
import { watcherActivity } from "./activity";
import { watcherConstructionComponent } from "./constructionComponent";
import { watcherDefaultConstructionComponent } from "./defaultConstructionComponent";
import { watcherConstructionPhase } from "./constructionPhase";
import { watcherDefaultConstructionPhase } from "./defaultConstructionPhase";
import { watcherConstructionComponentUnit } from "./constructionComponentUnit";
import { watcherToll } from "./tool";
import { watcherCalendar } from "./calendar";
import { watcherCheque } from "./cheque";
import { watcherWageRate } from "./wageRate";
import { watcherWageRateNew } from "./wageRateNew";
import { watcherEvent } from "./event";
import { watcherDashboard } from "./dashboard";
import { watcherImage } from "./image";
import { watcherOverallCost } from "./overallCost";
import { watcherOverallCostDetail } from "./overallCostDetail";
import { watcherChequeReview } from "./chequeReview";
import { watcherNotifications } from "./notification";
import { watcherInvitation } from "./invitation";
import { watcherBalanceSheet } from "./balanceSheet";
import { watcherCostAndProfit } from "./costAndProfit";
import { watcherPettyCash } from "./pettyCash";
import { watcherProjectSetting } from "./projectSetting";
import { watcherFile } from "./file";
import { watcherDownloadFile } from "./downloadFile";
import { watcherFeedback } from "./feedback";
import { watcherPremium } from "./premium";
import { watcherCashFlow } from "./cashFlow";
import { watcherWarnOwner } from "./warnOwner";
import { watcherTransaction } from "./transaction";
import { watcherCountryCode } from "./countryCode";
import { watcherCurrencies } from "./currencies";

export default function* rootSaga() {
  yield all([
    watcherInit(),
    watcherAuth(),
    watcherProject(),
    watcherProvince(),
    watcherContact(),
    watcherAccountReview(),
    watcherFund(),
    watcherBankAccount(),
    watcherBank(),
    watcherActivity(),
    watcherPayment(),
    watcherReceive(),
    watcherTransfer(),
    watcherConstructionComponent(),
    watcherDefaultConstructionComponent(),
    watcherConstructionComponentUnit(),
    watcherConstructionPhase(),
    watcherDefaultConstructionPhase(),
    watcherToll(),
    watcherCalendar(),
    watcherCheque(),
    watcherWageRate(),
    watcherWageRateNew(),
    watcherEvent(),
    watcherDashboard(),
    watcherImage(),
    watcherOverallCost(),
    watcherOverallCostDetail(),
    watcherChequeReview(),
    watcherNotifications(),
    watcherInvitation(),
    watcherPettyCash(),
    watcherProjectSetting(),
    watcherBalanceSheet(),
    watcherCostAndProfit(),
    watcherFile(),
    watcherDownloadFile(),
    watcherFeedback(),
    watcherPremium(),
    watcherCashFlow(),
    watcherWarnOwner(),
    watcherTransaction(),
    watcherCountryCode(),
    watcherCurrencies()
  ]);
}
